import { selectColumn } from "components/BaseTableV3/selectColumn";
import TagList from "components/TagList";
import { TableLink } from "components/BaseTableV3/TableLink";
import RuvixxDate from "components/RuvixxDate";
import { invalidateEmailTemplateTableQuery } from "hooks/useEmailTemplateTable";
import { EMAIL_TEMPLATE_TABLE_CONSTANTS } from "../EmailTemplateTableV3";
import { EmailTemplateTableActions } from "./EmailTemplateTableActions";
import EmailTemplateService from "services/EmailTemplate";

export const getEmailTemplateTableColumns = ({ options = [] }) => {
  return [
    selectColumn,
    {
      header: "ID",
      id: "ID",
      accessorKey: "id",
      size: 60,
      cell: ({ row }) => (
        <p style={{ fontWeight: "bold" }}>{row.original.id}</p>
      ),
    },
    {
      header: "Tags",
      id: "Tags",
      accessorKey: "tags",
      enableSorting: false,
      cell: ({ row }) => (
        <TagList
          tags={row.original.tags}
          modelType={EMAIL_TEMPLATE_TABLE_CONSTANTS.className}
          modelId={row.original.id}
          tableCell
          onUpdate={invalidateEmailTemplateTableQuery}
        />
      ),
    },
    {
      header: "Name",
      id: "Name",
      accessorKey: "name",
      cell: ({ row }) => {
        const { id, name, info } = row.original;
        let displayName = name;

        if (info?.image_swap_processing) {
          displayName = `${name} (Processing)`;
        } else if (info?.image_swap_error) {
          displayName = `${name} (Image Swap Error)`;
        }

        return (
          <TableLink
            href={`/settings/email_templates/${id}`}
            state={{
              options: { mergeTags: options },
            }}
          >
            {displayName}
          </TableLink>
        );
      },
    },
    {
      header: "Subject",
      id: "Subject",
      accessorKey: "subject",
    },
    {
      header: "Created At",
      id: "Created At",
      accessorKey: "created_at",
      cell: ({ row }) => {
        const value = row.original?.created_at;
        if (value !== undefined && value !== null) {
          return <RuvixxDate date={value} />;
        }
        return null;
      },
    },
    {
      header: <div></div>,
      id: "Actions",
      accessorKey: "actions",
      enableSorting: false,
      enableResizing: false,
      size: 60,
      meta: {
        isDisplay: true,
      },
      cell: ({ row }) => <EmailTemplateTableActions original={row.original} />,
    },
  ];
};

export const getEmailTemplateTableFilters = ({ tags = [] }) => {
  const filters = [
    {
      key: "created_at",
      title: "Created At",
      type: "dateRange",
    },
    {
      key: "template_id",
      title: "Name",
      type: "ruvixxSelect",
      queryFn: EmailTemplateService.getEmailTemplatesForFilters,
    },
    {
      key: "search:subject",
      title: "Subject",
      type: "input",
    },
    {
      key: "tag_id",
      title: "Tag",
      type: "tag",
      data: tags,
    },
  ];

  return filters;
};
